import { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import { Rating } from '@mui/material';
import StarRateIcon from '@mui/icons-material/StarRate';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Notify } from '../../../../components/Notify';
import { rateKnowledgeTrail } from '../../api';
import styles from './style.module.css';

interface ModalRateTrailProps {
  modalIsOpen: boolean;
  toggleModal: () => void;
  trailId: string;
  playerId: string;
  onRated?: () => void;
}

export function ModalRateTrail({
  modalIsOpen,
  toggleModal,
  trailId,
  playerId,
  onRated,
}: ModalRateTrailProps) {
  const [rating, setRating] = useState<number | null>(null);
  const [voted, setVoted] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (modalIsOpen) {
      setRating(null);
      setVoted(false);
    }
  }, [modalIsOpen]);

  async function handleRate(newValue: number | null) {
    if (newValue === null) return;
    setRating(newValue);
    setIsSaving(true);
    try {
      await rateKnowledgeTrail(trailId, playerId, newValue);
      setVoted(true);
      if (onRated) onRated();
    } catch (error) {
      setRating(null);
      Notify('Erro ao enviar sua avaliação. Tente novamente.', 'error');
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className={styles.contents}>
        <h2 className={styles.title}>Trilha finalizada!</h2>
        <p className={`${styles.detail} fw-bold`}>
          Por favor, avalie o conteúdo
        </p>
        <div className="d-flex justify-content-center">
          <Rating
            value={rating}
            precision={1}
            max={5}
            onChange={(e, newValue) => handleRate(newValue)}
            icon={<StarRateIcon style={{ width: '32px', height: '32px' }} />}
            emptyIcon={
              <StarOutlineIcon style={{ width: '32px', height: '32px' }} />
            }
            sx={{ '& .MuiRating-iconFilled': { color: '#ffc107' } }}
            disabled={voted || isSaving}
          />
        </div>
        {voted && (
          <p className={`${styles.detail} mt-3`}>Obrigado por sua avaliação!</p>
        )}
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={toggleModal}
          className={styles.btnConclude}
          type="button"
        >
          {voted ? 'Concluir' : 'Agora não'}
        </button>
      </div>
    </Modal>
  );
}
